var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "品牌(英)",
                            prop: "brandEn",
                            rules: [
                              {
                                required: true,
                                message: "品牌(英)不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写品牌(英)",
                              maxlength: 64,
                            },
                            model: {
                              value: _vm.inputForm.brandEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "brandEn", $$v)
                              },
                              expression: "inputForm.brandEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "规格(中)",
                            prop: "brandCn",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写规格(中)" },
                            model: {
                              value: _vm.inputForm.brandCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "brandCn", $$v)
                              },
                              expression: "inputForm.brandCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "规格(英)",
                            prop: "specEn",
                            rules: [
                              {
                                required: true,
                                message: "规格(英)不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写规格(英)" },
                            model: {
                              value: _vm.inputForm.specEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "specEn", $$v)
                              },
                              expression: "inputForm.specEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "规格(中)",
                            prop: "specCn",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写规格(中)" },
                            model: {
                              value: _vm.inputForm.specCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "specCn", $$v)
                              },
                              expression: "inputForm.specCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "数量", prop: "quantity", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写数量" },
                            model: {
                              value: _vm.inputForm.quantity,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "quantity", _vm._n($$v))
                              },
                              expression: "inputForm.quantity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "材料描述(英)",
                            prop: "descriptionEn",
                            rules: [
                              {
                                required: true,
                                message: "材料描述(英)不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 5 },
                              placeholder: "请填写材料描述(英)",
                            },
                            model: {
                              value: _vm.inputForm.descriptionEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "descriptionEn", $$v)
                              },
                              expression: "inputForm.descriptionEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "材料描述(中)",
                            prop: "descriptionCn",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 5 },
                              placeholder: "请填写材料描述(中)",
                            },
                            model: {
                              value: _vm.inputForm.descriptionCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "descriptionCn", $$v)
                              },
                              expression: "inputForm.descriptionCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }